document.addEventListener("DOMContentLoaded", () => {
  const lists = document.querySelectorAll("[data-rz-audio-list]");
  lists.forEach((list) => {
    const rows = list.querySelectorAll(".rz-audio__row");

    const stopAll = (exceptAudio = null) => {
      rows.forEach((row) => {
        const audio = row.querySelector("[data-rz-audio]");
        const icon = row.querySelector(".rz-audio__icon");
        if (!audio) return;

        if (audio !== exceptAudio) {
          audio.pause();
          audio.currentTime = 0;
          if (icon) icon.dataset.state = "paused";
        }
      });
    };

    rows.forEach((row) => {
      const btn = row.querySelector("[data-rz-audio-btn]");
      const audio = row.querySelector("[data-rz-audio]");
      const icon = row.querySelector(".rz-audio__icon");
      if (!btn || !audio || !icon) return;

      btn.addEventListener("click", async () => {
        // stop others
        stopAll(audio);

        if (audio.paused) {
          try {
            await audio.play();
            icon.dataset.state = "playing";
          } catch (e) {
            // autoplay restrictions / missing file
            icon.dataset.state = "paused";
          }
        } else {
          audio.pause();
          icon.dataset.state = "paused";
        }
      });

      audio.addEventListener("ended", () => {
        icon.dataset.state = "paused";
        audio.currentTime = 0;
      });
    });
  });
});